import React, { FC } from 'react';
import axios from 'axios';
import { Button } from '../Button/Button';
import { useTranslation } from "react-i18next";

interface OrganizationComponentStatsChartsExcelProps {
  fileName?: string;
  token: string;
  matrixId: string;
}

const OrganizationComponentStatsChartsExcel: FC<OrganizationComponentStatsChartsExcelProps> = ({ fileName = 'competence_stats.xlsx', token, matrixId }) => {
  const { t } = useTranslation();
  
  const handleDownload = async (): Promise<void> => {
    try {
      const response = await axios.get(
        `${window.APP_CONFIG.REACT_APP_API_BASEURL}/competence_tests/organization_test_results_excel`,
        {
          params: {
            matrix_pk: matrixId
          },
          headers: {
            Authorization: `Bearer ${token}`
          },
          responseType: 'blob'
        }
      );
      
      const blob = new Blob([response.data], { 
        type: response.headers['content-type'] || 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' 
      });
      
      const downloadUrl = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = downloadUrl;
      link.download = fileName;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(downloadUrl);
      
    } catch (error) {
      alert(t("reports.wrongDownload"));
    }
  };

  return (
    <Button variant="secondary" onClick={handleDownload}>
        {t("reports.download")}
    </Button> 
  );
};


export default OrganizationComponentStatsChartsExcel;